// Top Subcategories Carousel Id for Page Events
export const TOP_SUBCATEGORIES_ID = "home-top-sub-categories-carousel";
export const SECTION_HEADER_CONTENT_ID = "cid$#3359180#";

export const SUPPORTED_DPI_SETTINGS = ["1x", "2x", "2x"];
